export enum STORAGE {
	local, session
}



// WEBPACK FOOTER //
// ./src/services/jng2-webstorage/enums/storage.ts